import { RouterProvider } from 'react-router-dom';
import router from './routers/router';
import classes from './App.module.css';

function App() {
  return <RouterProvider router={router} />
}

export default App;